import customizeProNameArr from '@customizeProMixins/proNameArr'

// 定制化组件区分
let customizePro = null
customizePro = process.env.VUE_APP_CUSTOMIZE

if (!customizeProNameArr.includes(customizePro)) {
  // 不存在默认 mixtmt 项目
  customizePro = 'mixtmt'
}

export default customizePro
